import {isNotNil} from 'ramda-adjunct';

import {useGetSaleVehicleQuery} from '@dms/api/vehicle';
import {openCreateTestDriveDialog} from '@dms/features/test-drive';
import {usePermissions} from '@dms/shared';

/**
 * No business case is required up front: the dialog picks a customer and resolves — reuses or
 * creates — the selling business case in this vehicle's branch when the drive is saved.
 */
export const useCreateTestDriveAction = (vehicleId: string) => {
  const [hasCreateTestDrivePermission, hasCreateBusinessCaseSellingPermission] = usePermissions({
    permissionKeys: ['createTestDrive', 'createBusinessCaseSelling'],
  });

  const {data: saleVehicle} = useGetSaleVehicleQuery({vehicleId});

  const handleOpenCreateTestDriveDialog = (defaultSlot?: {start: Date; end: Date}) =>
    openCreateTestDriveDialog({
      vehicleId,
      branchId: saleVehicle?.branchId,
      defaultSlot,
      isVehicleChangeHidden: true,
      isDeleteHidden: true,
    });

  return {
    // The branch is what the new business case is filed under, so the flow cannot start without it.
    canCreateTestDrive:
      hasCreateTestDrivePermission &&
      hasCreateBusinessCaseSellingPermission &&
      isNotNil(saleVehicle?.branchId),
    openCreateTestDriveDialog: handleOpenCreateTestDriveDialog,
  };
};
